import {regionRelativeUrl} from "@/core/utils/helpers/regions/regionUrlHelper";
import {getCookie} from "@/core/utils/helpers/cookieHelper";
import CookiesEnum from "@/core/constants/cookiesEnum";
import {mapState} from "vuex";
import {decodeRot13, encodeRot13} from "@/core/utils/helpers/textHelpers";
import {AdvertPlaceholder} from "@/core/constants/advertConstants";

/**
 * @see docs/ads/native-advert-click-url.md — Native Advert Click URL convention.
 * Keep param shape (action, label, sessionId, deviceId, country, category, attributes[impression_id])
 * and ROT13 placeholder swap consistent with `buildGalleryAdvertClickUrl`
 * and `NativeAdInSearchComponent#clickUrl`.
 */
function advertClickUrl(advert, target, trackingLabel, impressionId = null) {
    try {
        if (this.hideExplicitRegionAds) {
            return window.open(
                regionRelativeUrl("/users/registration"),
                target,
            );
        }

        const xTrackingSessionIdCookie = getCookie(CookiesEnum.XTRACKING_DEVICE_ID);
        const xTrackingDeviceIdCookie = getCookie(CookiesEnum.XTRACKING_SESSION_ID);

        let baseUrl = '';
        if (advert.clickurl != null) {
            baseUrl = atob(advert.clickurl);
        }

        if (!baseUrl) {
            return window.open(regionRelativeUrl('/users/registration'), target);
        }

        const url = new URL(baseUrl);

        // Replace click_id placeholders with impression_id
        if (impressionId) {
            const placeholder = AdvertPlaceholder.CLICK_ID;
            const placeholderEncoded = encodeURIComponent(placeholder); // %24%24click_id%24%24
            const impressionIdEncoded = encodeURIComponent(impressionId);

            // Handle the 'to' parameter which is ROT13 encoded
            const toParam = url.searchParams.get('to');
            if (toParam) {
                // Decode ROT13 to get URL string (still has URL-encoded parameters)
                const rot13Decoded = decodeRot13(toParam);

                // Replace the URL-encoded placeholder with URL-encoded impression ID
                const replaced = rot13Decoded.replace(placeholderEncoded, impressionIdEncoded);

                // ROT13 encode back
                const finalEncoded = encodeRot13(replaced);

                url.searchParams.set('to', finalEncoded);
            }
        }

        url.searchParams.append('action', 'native-ads-click');
        url.searchParams.append('label', trackingLabel);
        url.searchParams.append('position', this.advert.position);
        url.searchParams.append('country', cou); // injected in header.blade.php
        url.searchParams.append('sessionId', xTrackingSessionIdCookie);
        url.searchParams.append('deviceId', xTrackingDeviceIdCookie);
        url.searchParams.append('sch', this.advert.searchId);

        if (this.fromProfile) {
            url.searchParams.append('category', 'profile');
        }

        if (impressionId) {
            url.searchParams.append('attributes[impression_id]', impressionId);
        }

        return window.open(url, target);
    } catch (e) {
        console.error('advertClickUrl', {advert: advert, exception: e})

        return window.open(regionRelativeUrl('/users/registration'), target);
    }
}

export default {
    methods: {
        advertClickUrl,
    },
    computed: {
        ...mapState(["hideExplicitRegionAds"]),
    },
};
